import styled from 'styled-components';
import Icon from '@minecraft.icon';
import { Link } from 'react-router-dom';
import { WithIsPreview } from '../styles/ProfileView';

export const MediaContainer = styled.div`
  background: ${(props): string => props.theme.colors.accent.greyBlue2};
  padding: 1rem 1rem 1rem 3rem;
  margin-bottom: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

export const MediaInfoWrap = styled.div`
  margin: 2.5rem 0;
  border-top: 0;
  padding: 0;
  @media screen and (min-width: 768px) {
    margin: 2.5rem -2rem 0;
    border-top: 0.0625rem solid ${(props): string => props.theme.colors.accent.ltGrey4};
    padding: 0 2rem;
  }
`;

export const InfoHeadingContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  @media screen and (max-width: 767px) {
    justify-content: space-between;
    border-bottom: 0.0625rem solid ${(props): string => props.theme.colors.primary.ltGrey1};
    margin-bottom: 1.5rem;
    padding-top: 1rem;
    padding-bottom: 1rem;
    align-items: center;
  }
`;

export const InfoHeading = styled.h3<WithIsPreview>`
  font-size: 1.7rem;
  line-height: 2rem;
  margin-top: ${(props): string => (props.isPreview ? '0' : '1.5rem;')};
  margin-bottom: ${(props): string => (props.isPreview ? '0' : '1.5rem;')};
  padding-bottom: ${(props): string => (props.isPreview ? '0' : '1rem;')};

  @media screen and (min-width: 768px) {
    font-size: 1.25rem;
    margin-bottom: 1.5rem;
    margin-top: 1.5rem;
    padding-left: 1rem;
    border-bottom: 0;
    padding-bottom: 0;
    color: ${(props): string => props.theme.colors.primary.darkGrey};
  }
`;

export const CustomModal = styled.div`
  margin-top: -2.25rem;
  h2 {
    font-size: 1.125rem;
    margin-bottom: 0.9375rem;
    word-break: break-word;
  }
  h1 {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
  }
  > div {
    padding-left: 0;
    padding-right: 0;
    border: 0;
    > div {
      margin-bottom: 1.5rem;
    }
  }
`;

export const StyledIcon = styled(Icon)`
  width: 1.0625rem;
  visibility: hidden;
  @media screen and (max-width: 767px) {
    visibility: visible;
  }
`;

export const StyledLink = styled(Link)`
  font-size: 1.125rem;
  font-weight: 600;
`;

export const StyledDivider = styled.span`
  flex-grow: 1;
  border-bottom: 0.0625rem solid ${(props): string => props.theme.colors.primary.ltGrey1};
  margin: 1rem;
`;
